import { api } from "@/lib/api";

export const adminUsersApi = {
    list: (params = {}) => api.get("/admin/users", { params }).then((r) => r.data),
    create: (payload) => api.post("/admin/users", payload).then((r) => r.data),
    update: (id, payload) => api.patch(`/admin/users/${id}`, payload).then((r) => r.data),
    remove: (id) => api.delete(`/admin/users/${id}`).then((r) => r.data),
};
